import type { AnyValue } from '@mntn-dev/utility-types'
import type { Namespace, TFunction, TOptions } from 'i18next'
import { createErrorMapRule } from './create-rule.ts'
import type { BaseIssueCode, TranslationKey } from './types.ts'

export function createBasicRule<
  TCode extends BaseIssueCode,
  TNamespace extends Namespace,
>(
  code: TCode,
  tKey: TranslationKey,
  t: TFunction<TNamespace>,
  options: TOptions = {}
) {
  return createErrorMapRule(code, t, (issue, ctx, t) => {
    return {
      message: t(tKey, { ...issue, ...ctx, ...options } as AnyValue) as string,
    }
  })
}
